/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTournamentProfileStats
 */
export interface UserTournamentProfileStats {
    /**
     * 
     * @type {number}
     * @memberof UserTournamentProfileStats
     */
    matchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentProfileStats
     */
    tournamentsPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentProfileStats
     */
    totalEarnings: number;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentProfileStats
     */
    favoriteGame: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentProfileStats
     */
    wins: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentProfileStats
     */
    losses: number;
}

/**
 * Check if a given object implements the UserTournamentProfileStats interface.
 */
export function instanceOfUserTournamentProfileStats(value: object): value is UserTournamentProfileStats {
    if (!('matchesPlayed' in value) || value['matchesPlayed'] === undefined) return false;
    if (!('tournamentsPlayed' in value) || value['tournamentsPlayed'] === undefined) return false;
    if (!('totalEarnings' in value) || value['totalEarnings'] === undefined) return false;
    if (!('favoriteGame' in value) || value['favoriteGame'] === undefined) return false;
    if (!('wins' in value) || value['wins'] === undefined) return false;
    if (!('losses' in value) || value['losses'] === undefined) return false;
    return true;
}

export function UserTournamentProfileStatsFromJSON(json: any): UserTournamentProfileStats {
    return UserTournamentProfileStatsFromJSONTyped(json, false);
}

export function UserTournamentProfileStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentProfileStats {
    if (json == null) {
        return json;
    }
    return {
        
        'matchesPlayed': json['matchesPlayed'],
        'tournamentsPlayed': json['tournamentsPlayed'],
        'totalEarnings': json['totalEarnings'],
        'favoriteGame': json['favoriteGame'],
        'wins': json['wins'],
        'losses': json['losses'],
    };
}

export function UserTournamentProfileStatsToJSON(json: any): UserTournamentProfileStats {
    return UserTournamentProfileStatsToJSONTyped(json, false);
}

export function UserTournamentProfileStatsToJSONTyped(value?: UserTournamentProfileStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchesPlayed': value['matchesPlayed'],
        'tournamentsPlayed': value['tournamentsPlayed'],
        'totalEarnings': value['totalEarnings'],
        'favoriteGame': value['favoriteGame'],
        'wins': value['wins'],
        'losses': value['losses'],
    };
}

